import { Component, Input } from '@angular/core';
import { EidosBaseComponent } from '../eidos-base.component';

@Component({
    selector: 'eidos-expandable-text',
    templateUrl: './eidos-expandable-text.component.html',
    styleUrls: ['./eidos-expandable-text.component.scss'],
    standalone: false
})
export class EidosExpandableTextComponent extends EidosBaseComponent {

  @Input() text: string = '';
  @Input() maxLength: number = 100;
  @Input() isHtml: boolean = false;


  isTextExpanded: boolean = false;

  get isTextLong(): boolean {
    return this.text.length > this.maxLength;
  }

  get shortText(): string {
    return this.text.substring(0, this.maxLength);
  }

  truncateText(text: string): string {
    if (text.length > this.maxLength) {
      return text.substring(0, this.maxLength) + '...';
    }
    return text;
  }

  constructor() {
    super();
  }

}
